<template>
    <page>
        <fast-table
            v-if="dataLoaded"
            :sections="sections"
            :headers="headers"
            :data="tableData"
            :activeRowId="currentAgreementId"
            @click="currentAgreementId = $event.id"
        >
            <template v-slot:table-actions>
                <button type="button" class="btn btn-primary btn-collapse-md" @click.prevent="currentAgreementId = null; addModalOpen = true">
                    <i class="far fa-fw fa-plus"></i>
                    <span class="btn-text">Add Reciprocal Agreement</span>
                </button>
            </template>
        </fast-table>

        <sidebar
            :key="currentAgreementId"
            :agreement="currentAgreement"
            v-if="currentAgreementId"
            @deactivated="currentAgreementId = null; getData()"
            @close="currentAgreementId = null"
        />

        <add-modal v-if="addModalOpen" @updated="getData()" @close="addModalOpen = false" />
    </page>
</template>

<script>
import FastTable from '@/components/FastTable'
import Page from '@/components/Page'
import AddModal from './components/TaxReciprocalAgreementModal'
import Sidebar from './components/TaxReciprocalAgreementSidebar'

export default {
    components: {FastTable, Page, AddModal, Sidebar},
    computed: {
        currentAgreement() {
            return this.agreements.find(a => a.id == this.currentAgreementId)
        },
        agreements_active() {
            return this.agreements.filter(a => a.is_active)
        },
        agreements_inactive() {
            return this.agreements.filter(a => !a.is_active)
        },
        tableData() {
            const subsets = [this.agreements_active, this.agreements_inactive]
            return subsets.map(subset =>
                subset.map(a => ({
                    id: a.id,
                    object: a,
                    cells: [
                        a.work_location_tax ? a.work_location_tax.description : '—',
                        a.resident_location_tax ? a.resident_location_tax.description : '—',
                    ],
                }))
            )
        },
    },
    data() {
        return {
            agreements: [],
            dataLoaded: false,
            currentAgreementId: null,
            addModalOpen: false,

            headers: [
                {label: 'Work Location Tax', classes: 'cw-5', isSearchable: true, isFilterable: true, defaultSort: true},
                {label: 'Resident Location Tax', classes: 'cw-10', isFilterable: true, isSearchable: true},
            ],
            sections: [
                {title: 'Active', defaultIsClosed: false, id: 1},
                {title: 'Inactive', defaultIsClosed: true, id: 2},
            ],
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Tax Engine / Tax Reciprocal Agreements')
        this.getData()
    },
    methods: {
        getData() {
            this.dataLoaded = false
            this.$store.dispatch('START_LOADING')
            this.$api.get('/admin/tax-engine/tax-reciprocal-agreements').then(resp => {
                this.agreements = resp
                this.dataLoaded = true
                this.$store.dispatch('STOP_LOADING')
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError(errors.__all__)
            })
        },
    },
}
</script>
